import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, MapPin } from 'lucide-react';
import api from '@/lib/api';
import SupportTicketForm from '@/components/SupportTicketForm';

export default function StaticPage({ type }) {
  const [site, setSite] = useState(null);

  useEffect(() => {
    api.get('/site-content').then(r => setSite(r.data)).catch(() => setSite({}));
  }, []);

  if (!site) {
    return <div className="h-screen flex items-center justify-center text-brand-ink">Loading…</div>;
  }

  const titleMap = {
    about: site.about_title,
    contact: site.contact_title,
    privacy: site.privacy_title || 'Privacy Policy',
    terms: site.terms_title || 'Terms of Service',
  };
  const bodyMap = {
    about: site.about_body,
    contact: site.contact_body,
    privacy: site.privacy_body || '',
    terms: site.terms_body || '',
  };
  const title = titleMap[type];
  const body = bodyMap[type];
  const showContactEmail = type === 'contact' && site.contact_email;

  return (
    <div className="min-h-screen bg-brand-paper" data-testid={`${type}-page`}>
      <div className="max-w-3xl mx-auto px-6 sm:px-10 py-10">
        <Link to="/" className="inline-flex items-center gap-2 text-brand-slate hover:text-brand-ink mb-8" data-testid="back-to-map">
          <ArrowLeft className="w-4 h-4" /> Back to the map
        </Link>

        <div className="flex items-center gap-2 mb-6">
          <MapPin className="w-5 h-5 text-brand" />
          <div className="font-display font-black text-2xl tracking-tight">
            <span className="text-brand-ink">{site.logo_text_left}</span>
            <span className="text-brand">{site.logo_text_right}</span>
          </div>
        </div>

        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight text-brand-ink leading-[1.05] mb-6">
          {title}
        </h1>

        <div className="glass-panel rounded-3xl p-7 sm:p-9">
          <p className="text-brand-slate text-base sm:text-lg whitespace-pre-wrap leading-relaxed" data-testid={`${type}-body`}>
            {body}
          </p>

          {showContactEmail && (
            <a
              href={`mailto:${site.contact_email}`}
              data-testid="contact-email-link"
              className="mt-7 inline-flex items-center gap-2 rounded-full bg-brand hover:bg-brand-hover text-white px-6 py-3 font-medium transition hover:-translate-y-0.5 shadow-lg"
            >
              <Mail className="w-4 h-4" /> {site.contact_email}
            </a>
          )}
        </div>

        {type === 'contact' && <SupportTicketForm />}
      </div>
    </div>
  );
}
